import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { t, loadLocales } from 'services/translation';

import BaseModal from 'ui_system/modals/BaseModal';
import { Theme } from 'ui_system/theme';
import TimezoneSelect from 'ui_system/select/timezone_select/TimezoneSelect';

const Modal = styled(BaseModal)`
  width: 520px;
`;

const Container = styled.div`
  padding: 40px 20px 30px 20px;
  color: ${Theme.colors.black};

  h1 {
    margin: 0;
    font-size: 18px;
    margin: 0 auto;
    width: fit-content;
  }

  h2 {
    margin-top: 20px;
    margin-bottom: 10px;
    font-size: 16px;
  }
`;

const Actions = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const DefaultButton = styled('button')`
  font-size: 16px;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 18px;
  padding-right: 18px;
  margin-top: 40px;
  border-radius: 4px;
  height: 44px;
  color: ${Theme.colors.black};
  width: 140px;

  border: 1px solid ${Theme.colors.inputs.border};
  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    display: none;
  }
`;

const ConfirmButton = styled(DefaultButton)`
  background: ${Theme.colors.green};
  color: white;
  border: 1px solid ${Theme.colors.green};

  @media (max-width: ${Theme.mobile.phoneWidth - 1}px) {
    display: block;
    width: 100%;
  }
`;

const TimezoneModal = ({ open, close, timezone, setTimezone }) => {
  const [selectedTimezone, setSelectedTimezone] = useState(timezone);
  const languageParam = new URL(window.location.href).searchParams.get('lang');
  loadLocales(languageParam || 'en-US');

  useEffect(() => {
    setSelectedTimezone(timezone);
  }, [timezone, open]);

  return (
    <Modal open={open} close={close}>
      <Container className="timezone-modal">
        <h1>{t('SWITCH_TIME_ZONE')}</h1>
        <h2>{t('TIME_ZONE')}</h2>
        <TimezoneSelect
          value={selectedTimezone}
          onChange={({ value }) => setSelectedTimezone(value)}
          styles={{ option: () => ({ color: Theme.colors.black }) }}
        />
        <Actions>
          <DefaultButton onClick={close}>{t('CANCEL')}</DefaultButton>
          <ConfirmButton
            onClick={() => setTimezone(selectedTimezone)}
            className="brand-bg brand-border"
          >
            {t('CHANGE')}
          </ConfirmButton>
        </Actions>
      </Container>
    </Modal>
  );
};

TimezoneModal.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  timezone: PropTypes.string.isRequired,
  setTimezone: PropTypes.func.isRequired,
};

export default TimezoneModal;
